
const audienceData = [
  {
    id: "aging-in-place",
    title: "Aging in Place",
    description: "Maintain independence and dignity with flexible care that adapts to your changing needs.",
    image: "/lovable-uploads/f7f7262c-bbd5-4cfe-8318-048d1a371591.png",
    features: [
      "Flexible visit schedules with no minimums",
      "Consistent care team that becomes like family",
      "Help with daily activities, medication management, and more",
      "Peace of mind for you and your loved ones"
    ]
  },
  {
    id: "recovery",
    title: "Recovery Patients",
    description: "Get the support you need to recover safely and comfortably at home after hospitalization or surgery.",
    image: "/lovable-uploads/3f3f8874-c9bc-485f-8dca-8c37e41d9dc6.png",
    features: [
      "Skilled nursing for post-operative care",
      "Medication management and wound care",
      "Assistance with daily activities during recovery",
      "Coordination with your healthcare providers"
    ]
  },
  {
    id: "family",
    title: "Family Caregivers",
    description: "We provide the respite and support you need to continue caring for your loved one without burning out.",
    image: "/lovable-uploads/4df344b2-6344-43c1-a22f-cef7884158a2.png",
    features: [
      "Flexible respite care when you need a break",
      "Supplemental care to fill in the gaps",
      "Peace of mind when you can't be there",
      "Expert guidance and support for your caregiving journey"
    ]
  },
  {
    id: "senior-housing",
    title: "Senior Housing",
    description: "Enhance your residents' experience with on-demand care that complements your existing services.",
    image: "/lovable-uploads/0f53bd83-5284-4f61-a576-93b76f30a0ac.png",
    features: [
      "On-demand care to supplement your staff",
      "After-hours coverage for emergencies",
      "Specialized care for residents with changing needs",
      "Seamless coordination with your team"
    ]
  },
  {
    id: "employers",
    title: "Employers",
    description: "Support your employees caring for aging parents with a valuable benefit that improves retention and productivity.",
    image: "/lovable-uploads/0c0d2668-d537-4508-9c25-969964db3caf.png",
    features: [
      "Reduce caregiver burnout and absenteeism",
      "Improve employee productivity and well-being",
      "Attract and retain talent with competitive benefits",
      "Simple implementation with clear ROI"
    ]
  }
];

export default audienceData;
